/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Already_Issued_PulledInputs */

const vi_einvoice_already_issued_pulled = /** @type {(inputs: Einvoice_Already_Issued_PulledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nháp này đã được ký trên MISA. Đã lấy số về.`)
};

/**

* @param {Einvoice_Already_Issued_PulledInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_already_issued_pulled = /** @type {((inputs?: Einvoice_Already_Issued_PulledInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Already_Issued_PulledInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_already_issued_pulled(inputs)
});